// import { useState } from "react"
import Button from "../../../components/button"
import CardContainer from "../../../components/card_container"
import Input from "../../../components/input"
import Select from "../../../components/select"
import InputImage from "../../../components/input_image"
import InputSwitch from "../../../components/input_switch"
import TextArea from "../../../components/text_area"
import "./productList.scss"
import UseFormProductList from "./hookForm"
import LoadingModal from "../../../components/loading_modal"
import useMultiStepForm from "../../../hooks/useMultiStepForm"
import useGet from "../../../hooks/useGet"
import { useMemo, useEffect } from "react"
import { useNavigate } from "react-router-dom";
import Toastify from "toastify-js";

const AddProductListPage = () => {
    const navigate = useNavigate();

    const {
        isLoading,
        handleSubmit: submitFinalForm,
    } = UseFormProductList({
        type: "post"
    })
    const showToast = (text, type = "success") => {
                Toastify({
                    text,
                    duration: 3000,
                    gravity: "top",
                    position: "right",
                    close: true,
                    stopOnFocus: true,
                    style: {
                        background:
                            type === "success"
                                ? "black"
                                : "black",
                    },
                }).showToast();
            };

    // Fetch fabric data
    const { data: fabricData } = useGet("/v1/fabric");
    // console.log("data add :",fabricData)
    
    // Fetch category data
    const { data: categoryData } = useGet("/v1/product-category");
    // console.log("data add categorry :",categoryData)

//     const fabricOptions = useMemo(() => {
//     if (!fabricData || !Array.isArray(fabricData)) return [];

//     return fabricData.map(fabric => ({
//         value: fabric._id || fabric.id,
//         label: fabric.fabric_name || fabric.name,
//         raw: fabric
//     }));
// }, [fabricData]);
const fabricOptions = useMemo(() => {
  if (!fabricData || !Array.isArray(fabricData)) {
    return [{ value: "", label: "Select fabric", disabled: true }];
  }

  return [
    { value: "", label: "Select fabric", disabled: true },
    ...fabricData.map(fabric => ({
      value: fabric._id || fabric.id,
      label: fabric.fabric_name || fabric.name,
      raw: fabric
    }))
  ];
}, [fabricData]);


    const {
        currentStep,
        formData,
        handleChange,
        handleFabricChange,
        handleImageChange,
        handleDrop,
        handleDropAttach,
        attachmentPreviews,
        handleAttachmentChange,
        removeImage,
        removeAttach,
        handleSwitch,
        nextStep,
        imagePreviews,
        productImages,
  attachments,
  productImagePreviews,
//   attachmentPreviews,
        prevStep,
        clearStorage
    } = useMultiStepForm({
        // Step 1 data
        product_code: "",
        category_id: "",
        product_name: "",
        price: "",
        description: "",
        product_image: null,
        // Step 2 data
        garment_description: "",
        color: "",
        fabric_id: "",
        fabric_type: "",
        product_description: "",
        fabric_product_description: "",
        image:"",
        // Step 3 data
        shipping_info: "",
        measuring_description: "",
        attachments: [],
        // Status
        is_active: true
    }, "productFormData", fabricOptions);

      useEffect(() => {
  console.log("🧾 FORM STATE:", formData);
}, [formData]);


//     // Convert fabric data to options
//     const fabricOptions = useMemo(() => {
//     if (!fabricData || fabricData.length === 0) return [];

//     return fabricData.map(fabric => ({
//         value: fabric._id || fabric.id,
//         label: fabric.fabric_name || fabric.name,
//         raw: fabric // ⬅️ PENTING
//     }));
// }, [fabricData]);


    // Convert category data to options
    // const categoryOptions = useMemo(() => {
    //     if (!categoryData || categoryData.length === 0) return [];
    //     return categoryData.map(products => ({
    //         value: products._id || products.id,
    //         label: products.name || products.category_name
    //     }));
    // }, [categoryData]);
    const categoryOptions = useMemo(() => {
  if (!categoryData || categoryData.length === 0) {
    return [{ value: "", label: "Select category", disabled: true }];
  }

  return [
      { value: "", label: "Select category", disabled: true },
      ...categoryData.map(products => ({
        value: products._id || products.id,
        label: products.name || products.category_name
      }))
    ];
  }, [categoryData]);
  const InputImage = ({ onChange, ...props }) => {
    return (
      <input
        type="file"
        {...props}
        onChange={(e) => onChange(e)}
      />
    );
  };
    

    const handleFinalSubmit = async (e) => {
    e.preventDefault();

    console.group("🚀 FINAL SUBMIT DEBUG");
    console.log("📦 Raw formData:", formData);
    console.groupEnd();

    const payload = new FormData();

    Object.entries(formData).forEach(([key, value]) => {
  if (value === null || value === undefined || value === "") return;

  // ❌ JANGAN proses file di sini
  if (key === "product_image" || key === "attachments") return;

  // file tunggal (kalau suatu saat ada)
  if (value instanceof File) {
    payload.append(key, value);
  }
  // array non-file (misalnya checkbox)
  else if (Array.isArray(value)) {
    value.forEach(v => payload.append(`${key}[]`, v));
  }
  // boolean / number / string
  else {
    payload.append(key, String(value));
  }
});
// 🔥 MULTI PRODUCT IMAGE
productImages.forEach((file) => {
  payload.append("product_image", file);
});

// 🔥 MULTI ATTACHMENT
attachments.forEach((file) => {
  payload.append("attachments", file);
});


    // 🔍 DEBUG — WAJIB ADA OUTPUT
  console.group("📤 FORM DATA SENT");
for (let pair of payload.entries()) {
  console.log(pair[0], pair[1]);
}
console.groupEnd();


   try {
    // ✅ submit
    await submitFinalForm(payload);

    // ✅ toast success
    showToast("Product berhasil disimpan", "success");

    // ✅ clear storage
    clearStorage();

    // ✅ redirect (beri delay biar toast kebaca)
    setTimeout(() => {
        navigate("/master/product_list", { replace: true });
 // ← ganti sesuai route kamu
    }, 800);

} catch (err) {
    console.error("❌ SUBMIT ERROR:", err);

    showToast(
        err?.message || "Gagal menyimpan data",
        "error"
    );
}

};
useEffect(() => {
  return () => {
    if (productImagePreviews) {
      URL.revokeObjectURL(productImagePreviews);
    }
  };
}, [productImagePreviews]);
useEffect(() => {
  console.log("IMAGE PREVIEWS:", productImagePreviews);
}, [productImagePreviews]);


useEffect(() => {
  return () => {
    if (attachmentPreviews) {
      URL.revokeObjectURL(attachmentPreviews);
    }
  };
}, [attachmentPreviews]);

// useEffect(() => {
//     console.log("🎯 SELECT VALUE:", formData.fabric_option);
// }, [formData.fabric_option]);
// useEffect(() => {
//     if (formData.fabric_id && fabricOptions.length) {
//         const found = fabricOptions.find(
//             o => o.value === formData.fabric_id
//         );
//         if (found) {
//             setFormData(prev => ({
//                 ...prev,
//                 fabric_option: found
//             }));
//         }
//     }
// }, [fabricOptions]);


//     const handleFinalSubmit = async (e) => {
//     e.preventDefault();

//     console.group("🚀 FINAL SUBMIT DEBUG");
//     console.log("📦 Raw formData:", formData);

//     // cek field kosong / undefined
//     Object.entries(formData).forEach(([key, value]) => {
//         if (
//             value === "" ||
//             value === null ||
//             value === undefined ||
//             (Array.isArray(value) && value.length === 0)
//         ) {
//             console.warn(`⚠️ EMPTY FIELD: ${key}`, value);
//         } else {
//             console.log(`✅ FIELD OK: ${key}`, value);
//         }
//     });

//     console.groupEnd();

//     await submitFinalForm(e, formData);
//     clearStorage();
// };


    // // Step Indicator Component - PERBAIKAN
    // const StepIndicator = () => (
    //     <div className="step-indicator">
    //         {[1, 2, 3].map((step) => (
    //             <div key={step} className={`step ${currentStep >= step ? 'active' : ''}`}>
    //                 <div className={`step-circle ${currentStep >= step ? 'active' : ''}`}>
    //                     {step}
    //                 </div>
    //                 {step < 3 && (
    //                     <div className={`step-line ${currentStep > step ? 'active' : ''}`} />
    //                 )}
    //             </div>
    //         ))}
    //     </div>
    // );

    // Step 1: General Information - PERBAIKAN SPACING
    const renderStep1 = () => (
        <div className="modern-form">
            <div className="header-title">
                <h2>{stepTitles[0]}</h2>
                <p className="subtitle">Fill in basic product information</p>
            </div>

            <div className="container-fluid px-lg-4 px-md-3 px-sm-2">
                <div className="row">
                    {/* Product Details - Left Column */}
                    <div className="col-lg-6 col-md-12">
                        <div className="form-section h-100">
                            <div className="section-title">
                                Product Details
                            </div>

                            <div className="mb-3 row g-3">
                                <div className="col-md-6 col-sm-12">
                                    <Input
                                        id="product_code"
                                        value={formData.product_code || ""}
                                        onChange={handleChange}
                                        label="Product Code"
                                        placeholder="PRD-001"
                                        required={true}
                                    />
                                </div>
                                <div className="col-md-6 col-sm-12">
                                   <Select
                                    options={categoryOptions}
                                    id="category_id"
                                    value={formData.category_id ?? ""}
                                    onChange={handleChange}
                                    label="Category Name"
                                    required
                                    />
                                </div>
                                <div className="col-md-6 col-sm-12">
                                    <Input
                                        id="product_name"
                                        value={formData.product_name || ""}
                                        onChange={handleChange}
                                        label="Product Name"
                                        placeholder="Enter product name"
                                        required={true}
                                    />
                                </div>
                            </div>

                            <div className="mb-3 row g-3">
                                <div className="col-md-6 col-sm-12">
                                    <Input
                                        id="price"
                                        value={formData.price || ""}
                                        onChange={handleChange}
                                        label="Price"
                                        placeholder="0.00"
                                        type="number"
                                        required={true}
                                    />
                                </div>
                            </div>

                            <div className="mb-3">
                                <TextArea
                                    id="description"
                                    value={formData.description || ""}
                                    onChange={handleChange}
                                    label="Product Description"
                                    placeholder="Describe your product features and benefits..."
                                    rows={4}
                                    required={true}
                                />
                            </div>
                        </div>
                    </div>

                    {/* Product Image & Status - Right Column */}
                    <div className="col-lg-6 col-md-12">
                        <div className="form-section h-100 d-flex flex-column">
                            <div className="section-title">
                                Product Image
                            </div>

                            <div className="mb-4 image-upload-section flex-grow-1">
                                <div className="upload-header">
                                    <label>Product Thumbnail</label>
                                    <span className="optional">Required</span>
                                </div>
                                <div
  className="image-upload-box"
  onDragOver={(e) => e.preventDefault()}
  onDrop={handleDrop}
>
  <input
    type="file"
    id="product_image"
    accept="image/jpeg,image/png,image/jpg"
    multiple
    hidden
    onChange={handleImageChange}
  />

  <label htmlFor="product_image" className="upload-label">
    Click or Drag Images Here
  </label>

{Array.isArray(productImagePreviews) && productImagePreviews.length > 0 && (
  <div className="mt-3 image-preview-grid">
    {productImagePreviews.map((src, i) => (
      <div key={i} className="preview-item">
        <img src={src} alt={`att-${i}`} />
        <button
          type="button"
          onClick={() => removeImage(i)}
        >
          ✕
        </button>
      </div>
    ))}
  </div>
)}



</div>

                                {/* <InputImage
    id="product_image"
    accept="image/jpeg,image/png,image/jpg"
    onChange={(e) => handleImageChange("product_image", e)}
    required
    />

    {imagePreview && (
    <div className="mt-3 image-preview">
        <img
        src={imagePreview}
        alt="Preview"
        style={{
            width: "100%",
            maxHeight: "250px",
            objectFit: "contain",
            borderRadius: "8px",
            border: "1px solid #ddd"
        }}
        />
    </div>
    )} */}

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

    // Step 2: Garment & Fabric Details - PERBAIKAN
    const renderStep2 = () => (
    <div className="modern-form">
        <div className="header-title">
            <h2>{stepTitles[1]}</h2>
            <p className="subtitle">Specify garment type and fabric information</p>
        </div>

        <div className="container-fluid px-lg-4 px-md-3 px-sm-2">
            <div className="row">
                <div className="col-lg col-md">
                    <div className="form-section h-100">
                        <div className="section-title">
                            Garment Information
                        </div>

                        <div className="mb-3 row g-3">
                            <div className="col-md col-sm">
                                <TextArea
                                    id="garment_description"
                                    value={formData.garment_description || ""}
                                    onChange={handleChange}
                                    label="Garment Description"
                                    placeholder="Provide a detailed description"
                                    required
                                />
                            </div>

                            <div className="col-md col-sm">
                                <Input
                                    id="color"
                                    value={formData.color || ""}
                                    label="Color"
                                    readOnly
                                />
                            </div>
                        </div>

                        {/* FABRIC SELECT */}
                        <div className="mb-3">
                          <Select
  options={fabricOptions}
  id="fabric_id"
  value={formData.fabric_id ?? ""}
  onChange={handleFabricChange}
  label="Fabric"
  required
/>


                        </div>

                        {/* AUTO FILLED */}
                        <div className="mb-3">
                            <Input
                                id="fabric_type"
                                value={formData.fabric_type || ""}
                                label="Type of Fabric"
                                readOnly
                            />
                        </div>

                        <div className="mb-3">
    <Input
        id="fabric_type"
        value={formData.image || ""}
        label="Image"
        readOnly
    />

    {formData.image && (
        <div className="mt-2">
            <img
                src={formData.image}
                alt="Preview"
                style={{
                    maxWidth: "100%",
                    height: "auto",
                    borderRadius: "8px",
                    border: "1px solid #ddd"
                }}
            />
        </div>
    )}
</div>


                        <div className="mb-3">
                            <Input
                                id="product_description"
                                value={formData.product_description || ""}
                                label="Product Description"
                                readOnly
                            />
                        </div>

                        <div className="mb-3">
                            <TextArea
                                id="fabric_product_description"
                                value={formData.fabric_product_description || ""}
                                label="Fabric Description"
                                readOnly
                                rows={4}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
);


    // Step 3: Shipping & Measurement - PERBAIKAN
    const renderStep3 = () => (
        <div className="modern-form">
            <div className="header-title">
                <h2>{stepTitles[2]}</h2>
                <p className="subtitle">Configure shipping options and measurement guide</p>
            </div>

            <div className="container-fluid px-lg-4 px-md-3 px-sm-2">
                <div className="row">
                    {/* Shipping Information - Left Column */}
                    <div className="col-lg-6 col-md-12">
                        <div className="form-section h-100">
                            <div className="section-title">
                                Shipping Information
                            </div>

                            <div className="mb-3 row g-3">
                                <div className="col-md-6 col-sm-12">
                                    <TextArea
                                        id="shipping_info"
                                        value={formData.shipping_info || ""}
                                        onChange={handleChange}
                                        label="Shipping Information"
                                        placeholder="Provide details about shipping policies, costs, and delivery times..."
                                        type="text"
                                        required={true}
                                    />
                                </div>
                                <div className="col-md-6 col-sm-12">
                                    <TextArea
                                        id="measuring_description"
                                        value={formData.measuring_description || ""}
                                        onChange={handleChange}
                                        label="Measuring Description"
                                        placeholder="Describe how to take measurements for custom fittings..."
                                        required={true}
                                    />
                                </div>
                            </div>

                            {/* <div className="mb-3 row g-3">
                                <div className="col-md-6 col-sm-12">
                                    <Select
                                        options={shippingOptions}
                                        id="shipping_methods"
                                        value={formData.shipping_methods || ""}
                                        onChange={handleChange}
                                        label="Shipping Methods"
                                        placeholder="Select methods"
                                        required={true}
                                    />
                                </div>
                                <div className="col-md-6 col-sm-12">
                                    <Input
                                        id="estimated_delivery"
                                        value={formData.estimated_delivery || ""}
                                        onChange={handleChange}
                                        label="Estimated Delivery"
                                        placeholder="3-5 business days"
                                        required={true}
                                    />
                                </div>
                            </div> */}
                        </div>
                    </div>

                    {/* Measurement Guide - Right Column */}
                    <div className="col-lg-6 col-md-12">
                        <div className="form-section h-100 d-flex flex-column">
  <div className="section-title">Attachment
  </div>
<div className="mb-4 image-upload-section flex-grow-1">
                                <div className="upload-header">
                                    <label>Attachament priviews</label>
                                    <span className="optional">Required</span>
                                </div>
                              
    <div
  className="image-upload-box"
  onDragOver={(e) => e.preventDefault()}
  onDrop={handleDropAttach}
>
  <input
    type="file"
    id="attachment"
    accept="image/jpeg,image/png,image/jpg"
    multiple
    hidden
    onChange={handleAttachmentChange}
  />

  <label htmlFor="attachment" className="upload-label">
    Click or Drag Images Here
  </label>

 {Array.isArray(attachmentPreviews) && attachmentPreviews.length > 0 && (
  <div className="mt-3 image-preview-grid">
    {attachmentPreviews.map((src, i) => (
      <div key={i} className="preview-item">
        <img src={src} alt={`att-${i}`} />
        <button
          type="button"
          onClick={() => removeAttach(i)}
        >
          ✕
        </button>
      </div>
    ))}
  </div> 
)}




  {/* {attachmentPreviews.length > 0 && (
  <div className="mt-3 image-preview-grid">
    {attachmentPreviews.map((src, index) => (
      <div key={index} className="preview-item">
        <img src={src} alt={`preview-${index}`} />
        <button
          type="button"
          onClick={() => removeAttach(index)}
        >
          ✕
        </button>
      </div>
    ))}
  </div>
)} */}

</div>
</div>

                    </div>
                </div>
            </div>
        </div>
        </div>
    );

    // Step Titles
    const stepTitles = [
        "General Information",
        "About this Garment, Fabric Details & Care Instructions",
        "Shipping Info & How to Get Measurement"
    ];
    useEffect(() => {
    console.group("✏️ FORM DATA CHANGED");
    console.table(formData);
    console.groupEnd();
}, [formData]);
useEffect(() => {
    console.group("📥 FABRIC API DEBUG");
    console.log("fabricData:", fabricData);
    console.log("Array?", Array.isArray(fabricData));
    console.groupEnd();
}, [fabricData]);

useEffect(() => {
    console.group("📥 CATEGORY API DEBUG");
    console.log("categoryData:", categoryData);
    console.log("Array?", Array.isArray(categoryData));
    console.groupEnd();
}, [categoryData]);
useEffect(() => {
    console.group(`📍 STEP CHANGED → STEP ${currentStep}`);
    console.log("Current formData:", formData);
    console.groupEnd();
}, [currentStep]);
    return (
        <>
            <CardContainer
                // title={`Add New Product`}
                // isBack={true}
                children={(
                    <form onSubmit={currentStep === 3 ? handleFinalSubmit : (e) => e.preventDefault()}>
                        {/* <StepIndicator /> */}

                        <div style={{ marginTop: '2rem' }}>
                            {currentStep === 1 && renderStep1()}
                            {currentStep === 2 && renderStep2()}
                            {currentStep === 3 && renderStep3()}
                        </div>

                        <div className="form-footer">
                            <div className="footer-actions">
                                <Button
                                    type="button"
                                    className="btn-danger"
                                    title="Discard"
                                    onClick={() => {
                                        clearStorage();
                                        window.history.back();
                                    }}
                                />

                                {currentStep > 1 && (
                                    <Button
                                        type="button"
                                        className="btn-outline-secondary"
                                        title="Previous"
                                        onClick={prevStep}
                                    />
                                )}

                                {currentStep < 3 ? (
                                    <Button
                                        type="button"
                                        className="btn-primary"
                                        title="Next Step"
                                        onClick={nextStep}
                                    />
                                ) : (
                                    <Button
                                        type="submit"
                                        className="btn-primary"
                                        title="Save Product"
                                        disabled={isLoading}
                                    />
                                )}
                            </div>

                            <div className="form-note">
                                Step {currentStep} of 3 • Data is automatically saved
                            </div>
                        </div>
                    </form>
                )}
            />
            <LoadingModal isLoading={isLoading} />
        </>
    )
}

export default AddProductListPage;